// extracted by mini-css-extract-plugin
export var parcelRow = "_tq-0";